// 分销
import { routes as ChannelRoutes } from './modules/channel/_routes'

// 路由按需加载
export const routes = [
  ...ChannelRoutes
]
